<template>
  <div class="pl-chats__avatar">
    <v-avatar v-if="icon && !entity.avatar && !entity.icon" :color="getColor">
      <v-icon dark>
        {{ icon }}
      </v-icon>
    </v-avatar>

    <v-avatar v-if="getAvatar || entity.icon">
      <img :src="getAvatar || iconSrc" alt="entity.name" />
    </v-avatar>

    <v-avatar v-if="!entity.avatar && !entity.icon && !icon" :color="getColor">
      <span class="white--text headline">
        {{ initials }}
      </span>
    </v-avatar>
  </div>
</template>

<script>
export default {
  name: 'PlChatAvatar',
  props: {
    entity: Object,
    entityColor: String,
    icon: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    iconSrc: '',
  }),
  computed: {
    getColor() {
      const defaultColor = '#009624'

      return this.entityColor ? this.entityColor : defaultColor
    },
    initials() {
      if (this.entity.name) {
        const names = this.entity.name.split(/\s/)

        if (names.length === 1) {
          return names[0][0].toUpperCase()
        } else {
          return names[0][0].toUpperCase() + names[1][0].toUpperCase()
        }
      }

      return null
    },
    getAvatar() {
      if (this.entity.icon) {
        if (typeof this.entity.icon === 'object') {
          const reader = new FileReader()

          reader.onload = e => {
            this.iconSrc = e.target.result
          }

          reader.readAsDataURL(this.entity.icon)
        } else {
          if (this.entity.icon.indexOf('https://') !== -1) {
            this.iconSrc = this.entity.icon
          } else {
            this.iconSrc = this.cropImg(this.entity.icon)
          }
        }

        return
      }
      if (this.entity.avatar) {
        if (this.entity.avatar.indexOf('https://') !== -1) {
          return this.entity.avatar
        } else {
          return this.cropImg(this.entity.avatar)
        }
      }

      return false
    },
  },
  methods: {
    cropImg(img) {
      const imageArr = img.split('/')
      const image = imageArr.pop()
      const imageName = image.split('.')[0]
      const imageExtension = image.split('.')[1]

      return `${this.$config.cdnServer}/images/${imageName}@100x100.${imageExtension}`
    },
  },
}
</script>

<style scoped lang="scss">
.pl-chats {
  &__avatar {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
    max-height: 48px;
    max-width: 48px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.5rem 0;
  }

  &__avatar-initials {
    text-transform: uppercase;
  }

  &__avatar-image {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
</style>
